var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.edmsId)?_c('EDMSDocument',{attrs:{"file":_vm.file}}):_vm._e(),_c('b-row',[_c('b-col',[(_vm.loading)?_c('b-spinner',{attrs:{"small":""}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }